import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'humanizeStatus',
  pure: true
})
export class HumanizeStatusPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) { return ''; }
    return value
      // split on underscores
      .toLowerCase()
      .split('_')
      // capitalize the first letter of each word
      .map(word => word[0].toUpperCase() + word.slice(1))
      .join(' ');
  }
}